import { Injectable } from '@angular/core';
import { ConnectIdentityConfig } from './connect-identity-config';
import { HOSTNAME } from './hostname';
import { ENV } from './env';
import { environment } from '../../../../environments/environment.prod';

@Injectable({
  providedIn: 'root',
})
export class DomainService {
  constructor() { }

  getConnectIdentityConfig(hostname: string): ConnectIdentityConfig {
    const connectIdentity: { [key: string]: any } = environment.connectIdentity;
    const env = this.getEnviroment(hostname);
    const config: ConnectIdentityConfig = connectIdentity[env];
    return config;
  }

  getBaseUrl(hostname: string): string {
    const env = this.getEnviroment(hostname);
    const api: { [key: string]: string } = environment.api;
    return api[env];
  }

  getBaseUrlForTenants(hostname: string): string {
    let env = this.getEnviroment(hostname);
    if (hostname === HOSTNAME.localhost) {
      env = ENV.stag;
    }
    let api: { [key: string]: string } = environment.api;
    if (hostname === HOSTNAME.int) {
      api = environment.kalmarApi;
    }
    return api[env];
  }

  getVismaHomeUri(hostname: string): string {
    const env = this.getEnviroment(hostname);
    const uri: { [key: string]: string } = environment.vismaHomeUri;
    return uri[env];
  }

  getGaiaChatApiUrl(hostname: string): string {
    const env = this.getEnviroment(hostname);
    const api: { [key: string]: string } = environment.gaiaChatApi;
    return api[env];
  }

  getVsnProfilePictureBaseUrl(hostname: string): string {
    const env = this.getEnviroment(hostname);
    const urls: { [key: string]: string } = environment.vsnNavigation.profilePictureBaseUrl;
    return urls[env];
  }

  getVsnMyProfileUrl(hostname: string): string {
    const env = this.getEnviroment(hostname);
    const urls: { [key: string]: string } = environment.vsnNavigation.myProfileUrl;
    return urls[env];
  }

  getVsnLandingPageUrl(hostname: string): string {
    const env = this.getEnviroment(hostname);
    const urls: { [key: string]: string } = environment.vsnNavigation.landingPageUrl;
    return urls[env];
  }

  getVsnBUs(hostname: string): string[] {
    const env = this.getEnviroment(hostname);
    const obj: { [key: string]: string[] } = environment.vsnBUs;
    return obj[env];
  }

  isVsnBU(buName: string, arr?: string[]): boolean {
    return (arr ?? []).includes(buName);
  }

  isUrlExcludedFromRetryStrategy(url: string): boolean {
    const arr: string[] = environment.excludedUrlsFromRetryStrategy;
    return this.indexOf(url, arr);
  }

  isConnectUrl(url: string): boolean {
    return (
      (this.isFromConnect(url, 'connect.') && !this.isFromConnect(url, '@')) ||
      this.isFromConnect(url, 'execute-api.eu-west-1.amazonaws.com')
    );
  }

  isConnectUserInfo(url: string): boolean {
    return (
      this.isFromConnect(url, '/connect/userinfo') ||
      this.isFromConnect(url, '/oauth2/userInfo')
    );
  }

  isContextsEndpoint(url: string): boolean {
    return (
      url.indexOf('/api/v1/contexts') > -1 ||
      url.indexOf('/v1/contexts') > -1
    );
  }

  skipSpinner(url: string): boolean {
    return url.indexOf('skipSpinner=true') > -1;
  }

  isTestable(hostname: string, userEmail: string): boolean {
    return (
      this.isTestHostname(hostname) ||
      environment.testUsers.indexOf(userEmail) > -1
    );
  }

  isTestHostname(hostname: string, excludeLocalhost?: boolean): boolean {
    if (excludeLocalhost) {
      return hostname === HOSTNAME.int || hostname === HOSTNAME.stag;
    } else {
      return (
        hostname === HOSTNAME.localhost ||
        hostname === HOSTNAME.int ||
        hostname === HOSTNAME.stag
      );
    }
  }

  isProduction(hostname: string): boolean {
    return hostname === HOSTNAME.prod;
  }

  getEnviroment(hostname: string): string {
    switch (hostname) {
      case HOSTNAME.int:
        return ENV.int;
      case HOSTNAME.stag:
        return ENV.stag;
      case HOSTNAME.prod:
        return ENV.prod;
      default:
        return ENV.localhost;
    }
  }

  private isFromConnect(url: string, segment: string): boolean {
    let is = false;
    if (url.indexOf(segment) > -1) {
      is = true;
    }
    return is;
  }

  private indexOf(str: string, arr: string[]): boolean {
    let is = false;
    for (let i = 0; i < arr.length; i++) {
      if (str.indexOf(arr[i]) > -1) {
        is = true;
        break;
      }
    }
    return is;
  }
}
